import { render, staticRenderFns } from "./PointLabelLarge.vue?vue&type=template&id=3d8b9859&scoped=true&"
import script from "./PointLabelLarge.vue?vue&type=script&lang=js&"
export * from "./PointLabelLarge.vue?vue&type=script&lang=js&"
import style0 from "./PointLabelLarge.vue?vue&type=style&index=0&id=3d8b9859&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8b9859",
  null
  
)

export default component.exports